import { useProject } from '@/contexts/ProjectContext';

export function ProjectSwitcher(): React.ReactElement | null {
  const { selectedProjectId, setSelectedProjectId, codebases, isLoadingCodebases } = useProject();

  if (isLoadingCodebases || !codebases || codebases.length === 0) return null;

  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="sr-only">Codebase</span>
      <select
        value={selectedProjectId ?? ''}
        onChange={e => {
          setSelectedProjectId(e.target.value || null);
        }}
        className="rounded-md border border-border bg-surface px-2 py-1 text-sm"
        aria-label="Select a codebase"
      >
        <option value="">Select a codebase…</option>
        {codebases.map(project => (
          <option key={project.id} value={project.id}>
            {project.github_repo_full_name ?? project.name}
          </option>
        ))}
      </select>
    </label>
  );
}
